import { GoogleAnalyticsSetting } from "../../domain/GoogleAnalyticsSlice/GoogleAnalyticsSetting";
import { GoogleAnalyticsSettingDelete } from "../../domain/GoogleAnalyticsSlice/GoogleAnalyticsSettingDelete";
import { GoogleAnalyticsSettingInsert } from "../../domain/GoogleAnalyticsSlice/GoogleAnalyticsSettingInsert";
import { GoogleAnalyticsSettingUpdate } from "../../domain/GoogleAnalyticsSlice/GoogleAnalyticsSettingUpdate";
import ApiWrapperAuthenticated from "../Common/ApiWrapperAuthenticated";

export class GoogleAnalyticsSettingRepository 
    extends ApiWrapperAuthenticated<void, GoogleAnalyticsSettingInsert, GoogleAnalyticsSettingUpdate, GoogleAnalyticsSettingDelete, void, GoogleAnalyticsSetting> {
    constructor() {
        super('google-analytics-settings/');
    }
}